// extracted by mini-css-extract-plugin
export default {"wrapper":"AdUnit_wrapper__CNfNh","ad":"AdUnit_ad__FajBl","placeholder":"AdUnit_placeholder__v8ok5","background":"AdUnit_background__Q8T3y","content":"AdUnit_content__Nti41"};